export class TooManyRequestsError extends Error {
    constructor() {
        super("Too many requests (429)");
        Object.setPrototypeOf(this, TooManyRequestsError.prototype);
    }
}